import { isResultsCategory } from '@/components/results-category/helpers/is-results-category.helper';
import { categoryPathMap } from '@/components/results-category/constants/category-path-map.constant';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
export function useGetPreviousPath() {
    var location = useLocation();
    var category = useSelector(function (state) { return state.dinTest.result.category; });
    var state = location.state;
    var from = state === null || state === void 0 ? void 0 : state.from;
    var path = category && isResultsCategory(category)
        ? "/result-category/".concat(categoryPathMap[category])
        : '/score-graph';
    var previousPath = from && from === '/hearing-aid-simulator' ? state.from : path;
    return { previousPath: previousPath };
}
